/** Shared lighter home-page CTA button styles */
export const homePrimaryButton = (theme) => ({
  "&&": {
    backgroundColor: theme.colors.orange[5],
    color: theme.white,
    fontWeight: 600,
    transition: "transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease",
    "&:hover": {
      backgroundColor: theme.colors.orange[6],
      transform: "translateY(-2px)",
      boxShadow: theme.shadows.sm,
    },
  },
});

export const homeOutlineOnDarkButton = (theme) => ({
  "&&": {
    borderColor: "rgba(255,255,255,0.75)",
    borderWidth: 2,
    color: theme.white,
    fontWeight: 600,
    backgroundColor: "rgba(255,255,255,0.08)",
    transition: "transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.18)",
      borderColor: theme.white,
      transform: "translateY(-2px)",
    },
  },
});
